// @flow

const CALORIES_KEY = ["cal", "unit"];

export { CALORIES_KEY };
